import { CircularProgress } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';

import { IS_AI_FEATURES_ENABLED, ROUTE_MAP, USER_ROLE } from '../constants';
import { useAuthContext } from '../hooks';
import {
  AidentifiedData,
  AIPrompts,
  BookingsReport,
  CallCenter,
  CallLog,
  Dashboard,
  EODReport,
  ForgotPassword,
  Login,
  Register,
  ResetPassword,
  Settings,
} from '../pages';
import { RootProvider } from '../providers';

const ROUTES_BY_USER_ROLE_MAP = {
  [USER_ROLE.CALLER]: (
    <>
      <Route path={ROUTE_MAP.DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTE_MAP.CALL_CENTER} element={<CallCenter />} />
      <Route path={ROUTE_MAP.BOOKINGS_REPORT} element={<BookingsReport />} />
    </>
  ),
  [USER_ROLE.MANAGER]: (
    <>
      <Route path={ROUTE_MAP.DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTE_MAP.BOOKINGS_REPORT} element={<BookingsReport />} />
      <Route path={ROUTE_MAP.SETTINGS} element={<Settings />} />
    </>
  ),
  [USER_ROLE.ADMIN]: (
    <>
      <Route path={ROUTE_MAP.DASHBOARD} element={<Dashboard />} />
      <Route path={ROUTE_MAP.BOOKINGS_REPORT} element={<BookingsReport />} />
      <Route path={ROUTE_MAP.CALL_LOG} element={<CallLog />} />
      <Route path={ROUTE_MAP.EOD_REPORT} element={<EODReport />} />
      <Route path={ROUTE_MAP.SETTINGS} element={<Settings />} />
      {IS_AI_FEATURES_ENABLED && (
        <>
          <Route path={ROUTE_MAP.AI_PROMPTS} element={<AIPrompts />} />
          <Route
            path={ROUTE_MAP.AIDENTIFIED_DATA}
            element={<AidentifiedData />}
          />
        </>
      )}
    </>
  ),
};

export const Router = () => {
  const { isUserRoleLoading, hasUserRole, userRole } = useAuthContext();

  if (isUserRoleLoading) {
    return (
      <div className="h-screen flex justify-center items-center">
        <CircularProgress size={120} sx={{ color: '#FFFFFF' }} />
      </div>
    );
  }

  return (
    <Routes>
      {hasUserRole ? (
        <Route element={<RootProvider />}>
          {ROUTES_BY_USER_ROLE_MAP[userRole]}
        </Route>
      ) : (
        <>
          <Route path={ROUTE_MAP.LOGIN} element={<Login />} />
          <Route path={ROUTE_MAP.REGISTER} element={<Register />} />
          <Route
            path={ROUTE_MAP.FORGOT_PASSWORD}
            element={<ForgotPassword />}
          />
          <Route path={ROUTE_MAP.RESET_PASSWORD} element={<ResetPassword />} />
        </>
      )}
      <Route
        path="/"
        element={
          <Navigate
            to={hasUserRole ? ROUTE_MAP.DASHBOARD : ROUTE_MAP.LOGIN}
            replace
          />
        }
      />
      <Route
        path="*"
        element={
          <Navigate
            to={hasUserRole ? ROUTE_MAP.DASHBOARD : ROUTE_MAP.LOGIN}
            replace
          />
        }
      />
    </Routes>
  );
};
